import React, { FC } from 'react';
import { Supersource } from './types';
import RequirableSelect from '../RequireableSelect';

interface SupersouceSelectFormGroupProps {
  selectedSupersourceId: number | undefined;
  supersources: Supersource[];
  formIndex: string;
  onChange: (supersourceId: number) => void;
  overrideFormName: string;
}

const SupersourceSelectFormGroup: FC<SupersouceSelectFormGroupProps> = ({
  formIndex,
  supersources,
  selectedSupersourceId,
  onChange,
    overrideFormName,
}) => {
  const supersourceOpts = supersources.map((supersource) => ({
    value: supersource.id,
    label: supersource.name,
  }));
  let formName = 'module_instances';
  if (overrideFormName !== undefined) {
    formName = overrideFormName;
  }

  return (
    <div className="form-group">
      <label htmlFor={`${formName}-${formIndex}-supersource`}>
        SUPERSOURCE
      </label>
      <RequirableSelect
        options={supersourceOpts}
        isSearchable
        required
        onChange={evt => onChange(evt.value)}
        name={`${formName}-${formIndex}-supersource`}
        inputId={`${formName}-${formIndex}-supersource`}
        value={supersourceOpts.find(opt => opt.value === selectedSupersourceId) ?? null}
      />
    </div>
  );
};

export default SupersourceSelectFormGroup;
